import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { routes } from '../../../navigation/Router'

const SignupInstructions: React.FC = () => {
  const { t } = useTranslation()
  const contactPerson = {
    email: 'contact@icure.com',
    phone: '+32 2 333 58 46',
  }
  return (
    <>
      <div className="auth-form">
        <div className="auth-form__title">
          <h2>{t('signupInstructions.title')}</h2>
        </div>

        <div className="auth-form__instructions">
          <p>{t('signupInstructions.line1')}</p>
          <p>{t('signupInstructions.line2')}</p>
        </div>
        <div className="auth-form__instructions">
          <div>
            <h6>{t('signupInstructions.emailLabel')}</h6>
            <a href={`mailto:${contactPerson.email}`}> {contactPerson.email}</a>
          </div>
          <div>
            <h6>{t('signupInstructions.phoneLabel')}</h6>
            <a href={`tel:${contactPerson.phone}`}> {contactPerson.phone}</a>
          </div>
        </div>
        <div className="auth-form__instructions">
          <p>{t('signupInstructions.helpLine')}</p>
        </div>

        <div className="auth-form__textHelper">
          <p>
            {t('signupInstructions.alreadyAccount')}{' '}
            <Link className="link" to={routes.login}>
              {t('signupInstructions.loginLink')}
            </Link>
          </p>
        </div>
      </div>
    </>
  )
}

export default SignupInstructions
